const getLocale = () => {
  if (document.documentElement.lang) {
    return document.documentElement.lang.split('-')[0];
  }

  return 'en';
};

const messages = {
  en: {
    cookies: {
      button: {
        acceptAll: 'Accept All',
        confirm: 'Confirm'
      },
      info: {
        disabled: 'Please enable cookies to view this content'
      }
    },
  },
  de: {
    cookies: {
      button: {
        acceptAll: 'Alle akzeptieren',
        confirm: 'Bestätigen'
      },
      info: {
        disabled: 'Bitte aktivieren Sie Cookies, um diesen Inhalt anzuzeigen'
      }
    },
  },
};

const initI18n = () => {
  if (window.AlpineI18n && typeof window.AlpineI18n.create === 'function') {
    const locale = getLocale();
    window.AlpineI18n.create(locale, messages);
  }
};

export const setupI18n = () => {
  if (window.AlpineI18n) {
    initI18n();
  } else {
    document.addEventListener("alpine-i18n:ready", initI18n);
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initI18n, 100);
      });
    } else {
      setTimeout(initI18n, 100);
    }
  }
};
